import React, { useState } from 'react'
import Buttons from '../../components/UI/Buttons'
import Skeleton from '../../components/SkeletonComponent/Skeleton'
import FormInputs from '../../components/UI/FormInputs';

const OrganSection = (props) => {
const [organList, setOrganList] = useState([]);


  const FormInput=[
    { 
      label:"Claim Number",
      value:"122334455",
    },
     { 
      label:"Authorization",
      value:"",
    },
     { 
      label:"Followup",
      value:"",
    },
     { 
      label:"Referrals",
      value:"",
    }
  ]
  return (
   <div className="sh_cardBox mb-3 h-auto sh_cardbglight">
      <div className="sh_cardHeader ">
        <div className="d-flex align-items-center sh_emrorganSectionHeader justify-content-between">
          <h6 className="text-md font-weight-bold mb-0">Injury/Illness details</h6>
          {((props.visit_category==="Work Comp - New Injury" || props.visit_category==="Work Comp - Follow Up") || 
            ((props.visit_category==="Work Comp - Physical Therapy" || props.visit_category==="Work Comp - Other") && 
             props.incidentDetails && props.incidentDetails.incident_id) ||
            ['Urgent Care - Injury', 'Urgent Care - Illness', 'Urgent Care - Follow Up', 'Urgent Care - Cash Patient', 'Urgent Care - Telehealth',
             'Private - Mental Health Exam', 'Private - Primary Care - Initial', 'Private - Primary Care - Follow Up'].includes(props.visit_category)) && 
              <Buttons
                className="btn btn-link"
                label={"View More"}
                acl={'any'}
                clickHandler={props.incidentToogleHanlder}
              />
            }
        </div>
      </div>
      <div className="sh_cardBody py-0">
        <div > 
          <FormInputs
              type="CheckboxDropDown"
              label="Organ Name"
              placeholder="Organ Name"
              className="form-control form-control-solid"
              name="organ_name"
              options={organList}
              value={props.selectedBodyPart}
              isMulti={1}
              changeHandler={(opt,ismulti,val)=>props.handleEvent(opt.value,val)}
            />
        </div>
        <div className="d-flex justify-content-center sh_emrorganSectionCard sh_bgdotted">
          <Skeleton onClick={props.handleEvent}
            editValue={props.selectedBodyPart}
            isMultiSelect={true}
            width="300"
            height="400"
            setOrganList={(val) => setOrganList(val)} />
         
        </div>
        <div className="row">
          {FormInput.map((input, index) => (
            <React.Fragment key={index}>
              <div className="col-lg-6 col-md-12 col-12 pt-2">
                <label className="f-400 text-sm text-truncate mb-0 opacity-75">{input.label}</label>
              </div>
              <div className="col-lg-6 col-md-12 col-12 pt-2">
                <h6 className="font-weight-bold text-sm text-lg-right text-md-left text-truncate mb-0" title="">
                  {input.value || '-'}
                </h6>
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}

export default OrganSection